import { isString as o } from "./chunk312.js";
const n = (t) => {
  try {
    const e = /[-]{0,1}[\d]*[.]{0,1}[\d]+/, r = t.match(e);
    return o(t) ? parseFloat(t) : r != null && r.length ? parseFloat(r[0]) : NaN;
  } catch {
    return NaN;
  }
};
export {
  n as parseToNumber
};
